import React from "react";
import Rollbar from '../utils/RollbarTracking'
import axios from 'axios'
import moment from 'moment'
import Select from 'react-select';
import { toast } from 'react-toastify';
import Cache from '@aws-amplify/cache';

export class OrdersEdit extends React.Component {
  constructor(props)  {
    super(props);
    this.handleChangeQty = this.handleChangeQty.bind(this);
    this.handleChangeUnitPrice = this.handleChangeUnitPrice.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
  }

  state = {
      myOrderData: {},
      orderLineItems: [],
      paymentDueDate: null,
      products: [],
      totalAdjustment: 0,
      newTotal: 0,
      subTotal: 0,
      updateBasePrices: Cache.getItem('supplier_update_price_mode' + this.props.user.supplierID),
      comment: '',
      deliveryDays: [],
      selectedDeliveryDay: '',
      loading: false
  }

  componentWillMount() {
    this.fetchOrderData();
    this.fetchOrderLineItems()
    this.fetchProductData()
    this.showUpdateModeToast()
  }

  componentWillUnmount() {
    toast.dismiss()
  }

  showUpdateModeToast() {
    if (this.state.updateBasePrices) {
      toast.success(({ closeToast }) => 
        <div className="row m-0">
          <div className="col-9 my-auto p-0">Update Price List Mode</div>
          <div className="col-3">
            <button type="button" onClick={() => this.toggleUpdateMode()} className="btn btn-success btn-sm">Exit</button>
          </div>
        </div>, {
        className: "edit-pricelist-mode-toast",
        position: "bottom-right",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        closeButton: false
      });
    } else {
      toast.dismiss()
    }
  }

  toggleUpdateMode() {
    this.setState({ updateBasePrices: !this.state.updateBasePrices }, () => {
      this.showUpdateModeToast()
      Cache.setItem('supplier_update_price_mode' + this.props.user.supplierID, this.state.updateBasePrices)
    })
  }

  updateTotal(adjustment) {
    var total = 0
    for (let i = 0; i < this.state.orderLineItems.length; i++) {
      total += this.state.orderLineItems[i].unitPrice*this.state.orderLineItems[i].quantity
    }
    var subTotal = total
    total += Number(adjustment)
    this.setState({newTotal: total.toFixed(2), subTotal: subTotal.toFixed(2)})
  }

  handleChangeQty (evt) {
    var orderLineItems = this.state.orderLineItems
    orderLineItems[evt.target.name].quantity = evt.target.value
    this.setState({ orderLineItems: orderLineItems }, () => {
      this.updateTotal(this.state.totalAdjustment)
    });
  }

  handleChangeUnitPrice (evt) {
    var orderLineItems = this.state.orderLineItems
    orderLineItems[evt.target.name].unitPrice = evt.target.value
    this.setState({ orderLineItems: orderLineItems }, () => {
      this.updateTotal(this.state.totalAdjustment)
    });
  }

  handleChange (evt) {
    let val = evt.target.value
    this.setState({ [evt.target.name]: evt.target.value }, () => {
      this.updateTotal(val)
    });
  }

  handleChange2 (evt) {
    this.setState({ [evt.target.name]: evt.target.value })
  }

  handleChangeSelect(obj, evt) {
    var orderLineItems = this.state.orderLineItems
    orderLineItems[evt.name].productID = obj.productID
    orderLineItems[evt.name].name = obj.productName
    orderLineItems[evt.name].unitPrice = obj.price
    this.setState({ orderLineItems: orderLineItems }, () => {
      this.updateTotal(this.state.totalAdjustment)
    });
  }

  calculatePaymentDate(dateString, paymentDays) {
    var d = moment(dateString, 'DD-MM-YY').add(paymentDays, 'days')
    return d.format('DD-MM-YY');
  }

  fetchOrderData = async () => {
    axios.get('/orders/' + this.props.match.params.id)
        .then(data => {
          this.setState({
            myOrderData: data[0],
            newTotal: data[0].total,
            subTotal: data[0].total,
            totalAdjustment: data[0].adjustment,
            comment: data[0].comment,
            selectedDeliveryDay: data[0].deliveryDay
          });
          this.fetchDeliveryDays(data[0].customerID, data[0].deliveryDay)
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.error('Failed to get order record')
        })
  }

  fetchOrderLineItems = async () => {
    axios.get('/orders/' + this.props.match.params.id + '/lineitems')
        .then(data => {
          this.setState({
            orderLineItems: data,
          });
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.error('Failed to get order line items')
        })
  }

  fetchProductData = async () => {
    axios.get('/products/order/' + this.props.match.params.id)
        .then(data => {
          this.setState({
            products: data
          });
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.error('Failed to get products')
        })
  }

  fetchDeliveryDays = async (customerID, currentDeliveryDay) => {
    axios.get('/customers/' + customerID + '/deliverydays')
        .then(data => {
          if (data.deliveryDays.findIndex(e => e.str === currentDeliveryDay) === -1) {
            data.deliveryDays.unshift({str: currentDeliveryDay})
          }
          this.setState({
            deliveryDays: data.deliveryDays
          });
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.error('Failed to get delivery days')
        })
  }

  saveChanges = async () => {
    if (Math.sign(this.state.newTotal) === -1) {
      toast.error('Total cannot be negative')
    } else if (this.state.orderLineItems.length === 0) {
      toast.error('Order must contain at least 1 line item')
    } else if (this.state.orderLineItems.some(e => !e.productID)) {
      toast.error('Order contains empty line items')
    } else if (this.state.orderLineItems.some(e => e.unitPrice === '')) {
      toast.error('Order contains line items with empty price')
    } else if (this.state.orderLineItems.some(e => e.quantity === '')) {
      toast.error('Order contains line items with empty quantity')
    } else {
      let requestParams = {
        'orderID': this.props.match.params.id,
        'totalAdjustment': this.state.totalAdjustment,
        'newTotal': this.state.newTotal,
        'orderLineItems': this.state.orderLineItems,
        'updateBasePrices': this.state.updateBasePrices,
        'comment': this.state.comment,
        'deliveryDay': this.state.selectedDeliveryDay
      }
      this.setState({loading: true})
      axios.post('/orders/edit', requestParams)
          .then(data => {
            this.setState({loading: false})
            this.props.history.push("/orders/view/" + this.props.match.params.id)
          })
          .catch (err => {
            this.setState({loading: false})
            console.error(err)
            Rollbar.error(err)
            toast.error('Failed to save changes')
          })
    }
  }

  deleteLineItem(index) {
    var lineItems = this.state.orderLineItems
    lineItems.splice(index,1)
    this.setState({orderLineItems: lineItems})
    this.updateTotal(this.state.totalAdjustment)
  }

  addLineItem() {
    var lineItems = this.state.orderLineItems
    lineItems.push({
      productID: '',
      name: '',
      unitPrice: 0,
      quantity: 1
    })
    this.setState({orderLineItems: lineItems})
  }

  statusBadge(status) {
    if (status == 'Pending') {
      return <span className="badge badge-warning">Pending</span>
    } else if (status == 'Accepted') {
      return <span className="badge badge-info">Accepted</span>
    } else if (status == 'Invoiced') {
      return <span className="badge badge-success">Invoiced</span>
    } else if (status == 'Paid') {
      return <span className="badge badge-secondary">Paid</span>
    }
  }

    render() {
        return (
          <div>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
              <h1 className="h3">Edit Order</h1>
            </div>
            <div className="mar-bot-lg">
              <button type="button" onClick={() => this.saveChanges()} className="btn btn-success btn-sm mar-bot mar-right" disabled={this.state.loading}>Save Changes</button>
              {this.props.settings ? <button type="button" onClick={() => this.toggleUpdateMode()} className="btn btn-info btn-sm mar-bot" disabled={this.props.settings.integration.type}>Toggle Update Price Mode</button> : null}
              <div className="card">
                <div className="card-header">
                  Order No.
                  <strong>{this.state.myOrderData.orderID}</strong>
                  <span className="float-right"> <strong>Status: </strong>{this.statusBadge(this.state.myOrderData.status)}</span>
                </div>
                <div className="card-body">
                  <div className="row mb-4">
                    <div className="col-sm-7">
                      <h6 className="mb-3">Customer:</h6>
                      <div>
                        <strong>{this.state.myOrderData.company}</strong>
                      </div>
                      <div>{this.state.myOrderData.name}</div>
                      <div>{this.state.myOrderData.address}</div>
                      <div>Email: {this.state.myOrderData.email}</div>
                      <div>Phone: {this.state.myOrderData.phone}</div>
                    </div>
                    <div className="col-sm-5">
                      <h6 className="mb-3">Order Details:</h6>
                      <div>
                        <strong>{this.props.user.name}</strong>
                      </div>
                      <div className="input-select">
                        <label className="mb-0">Delivery Day:</label>
                        <select value={this.state.selectedDeliveryDay} onChange={this.handleChange2} className="form-control mini" name="selectedDeliveryDay">
                          {this.state.deliveryDays.map((data, i) =>
                            <option key={i}>{data.str}</option>
                          )}
                        </select>
                      </div>
                      {/* <div>Order No: {this.props.match.params.id}</div> */}
                      {/* <div>Delivery Day: {this.state.myOrderData.deliveryDay}</div> */}
                      <div>Payment Due by: {this.state.myOrderData.paymentDue}</div>
                      <div>Date Placed: {this.state.myOrderData.date}</div>
                    </div>
                  </div>
                  <div className="table-responsive-sm">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th className="center">#</th>
                          <th>Item</th>
                          <th className="right">Unit Cost</th>
                          <th className="center">Qty</th>
                          <th className="right">Total</th>
                          <th className="right">Action</th>
                        </tr>
                      </thead>
                        <tbody>
                          {this.state.orderLineItems.map((data, i) =>
                            <tr key={i}>
                              <td className="center">{i + 1}</td>
                              <td className="left strong select-editorder">
                              <Select
                                name={i}
                                value={data}
                                onChange={this.handleChangeSelect}
                                options={this.state.products}
                                getOptionLabel={(option)=>option.productName||option.name}
                                getOptionValue={(option)=>option.productID}
                              />
                              </td>
                              <td className="right"><input type="number" min="0" className={this.state.updateBasePrices ? "medium-input border-green" : "medium-input"} value={data.unitPrice} onChange={this.handleChangeUnitPrice} name={i} step="0.05" /></td>
                              <td className="center"><input type="number" min="1" className="small-input" value={data.quantity} onChange={this.handleChangeQty} name={i} /></td>
                              <td className="right">{(data.unitPrice*data.quantity).toFixed(2)}</td>
                              <td className="right"><button type="button" onClick={() => this.deleteLineItem(i)} className="btn btn-danger btn-sm">X</button></td>
                            </tr>
                          )}
                          <tr>
                            <td className="orderAdd"><button type="button" onClick={() => this.addLineItem()} className="btn btn-success btn-sm">+</button></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tbody>
                    </table>
                  </div>
                  <div className="row">
                    <div className="col-lg-4 col-sm-5">
                      <h6>Comment:</h6>
                      <textarea name="comment" value={this.state.comment} onChange={this.handleChange2} rows="2" cols="30" />
                    </div>
                    <div className="col-lg-4 col-sm-5 ml-auto">
                      <table className="table table-clear">
                        <tbody>
                          <tr>
                            <td className="left">
                              <strong>Subtotal</strong>
                            </td>
                            <td className="right">${this.state.subTotal}</td>
                          </tr>
                          {this.props.settings.integration.type ? null :
                          <tr>
                            <td className="left">
                              <strong>-/+ Adjustment</strong>
                            </td>
                            <td className="right">$<input type="number" className="" value={this.state.totalAdjustment} onChange={this.handleChange} name="totalAdjustment" /></td>
                          </tr> }
                          <tr>
                            <td className="left">
                              <strong>Total</strong>
                            </td>
                            <td className="right">
                              <strong>${this.state.newTotal}</strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
    }
}
